<ngx-spinner bdOpacity=0.5 bdColor="rgba(0,0,0,0.84)" size="default" color="#fff" type="ball-pulse" [fullScreen]="true">
</ngx-spinner>
<ng-container *ngIf="podcastDetailRes && podcastDetailRes?.podcast_name">
    <div class="col-12 podcast-episode greenlight-bg">
        <div class="row">
            <div class="col-12 e-card-header">
                <div class="e-card-inner row">
                    <div class="container">
                        <div class="e-card-img">
                            <img alt="{{podcastDetailRes?.podcast_name}}" src="{{podcastDetailRes?.podcast_image}}">
                        </div>
                        <div class="e-card-content">
                            <h4>{{podcastDetailRes?.podcast_name}}</h4>
                            <ul class="e-card-info">
                                <li><a href="javascript:void(0);" class="e-share"><img src="assets/images/podcasts/Popular-podcasts/share-icon-white.png" alt="share-icon-white"> Share</a></li>
                            </ul>
                            <p>{{podcastDetailRes?.podcast_description}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-12 ads-top text-center">
                        <img src="assets/images/podcasts/Popular-podcasts/ads-small.jpg" alt="ads-small">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-lg-2 ads-space">
                        <!--------------------Blank Space------------->
                    </div>
                    <div class="col-12 col-lg-8 center-wrapper">
                        <div class="row">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 episodeList-title">
                                        <h3>Episodes</h3>
                                    </div>
                                    <div class="col-12 episodeList">
                                        <div class="row">
                                            <div class="col-12 e-card" *ngFor="let episode of episodeList;let i=index;" routerLink="/podcasts-web/episode/{{episode?.alias}}">
                                                <div class="e-card-inner">
                                                    <div class="e-card-left">
                                                        <div class="e-card-img">
                                                            <img  alt="{{episode?.title}}" src="{{episode?.thumbnail}}">
                                                        </div>
                                                        <div class="e-card-content">
                                                            <div class="inline-type">
                                                                <h4>{{episode?.title}}</h4>
                                                                <ul class="e-card-info">
                                                                    <li><img src="assets/images/podcasts/Popular-podcasts/calendar-icon.png" alt="calendar-icon"><div class="date">{{episode?.created_at | date:'MMM dd yyyy'}}</div></li>
                                                                    <li><img src="assets/images/podcasts/Popular-podcasts/clock-icon.png" alt="clock-icon"><div>{{secondsToDhms(episode?.audio_length_sec)}}</div></li>
                                                                </ul>
                                                            </div>
                                                            <p>{{episode?.description}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="shareNplay">
                                                        <div class="d-flex">
                                                            <a href="javascript:void(0);" class="e-share"><img src="assets/images/podcasts/Popular-podcasts/share-icon.png" alt="share-icon"> Share</a>
                                                            <a  href="javascript:void(0);" (click)="playAudio(episode);$event.stopPropagation();" class="e-play"><img src="assets/images/podcasts/Popular-podcasts/play-icon.png" alt="play-icon"></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        </div>
                                        <!-- <div class="row">
                                            <div class="col-12 mt-4 text-center">
                                                <a href="javascript:void(0);" class="btn btn-green">View More</a>
                                            </div>
                                        </div> -->

                                        <div class="row pad-btm-30" *ngIf="totalPages != page">
                                            <ng-container *ngIf="totalPages >= page">
                                            <div class="col-12 mt-4 text-center">
                                                <!-- <a href="javascript:void(0);" class="btn btn-green" (click)="viewMore((pager?.currentPage*1) + (1*1))">View More</a> -->
                                                <a href="javascript:void(0);" class="btn btn-green" (click)="viewMore()">View More</a>
                                            </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 ads-space">
                        <div class="ads-wrapper">
                            <img src="assets/images/podcasts/Popular-podcasts/ads-side.jpg" alt="ads-side">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- <div class="row banner-dashboard-header">
    <div class="col-md-12">
        <div class="list_banner">
            <div class="row list-banner-inner">
                <div class="col-md-3 img-box">
                    <img alt="{{podcastDetailRes?.podcast_name}}" src="{{podcastDetailRes?.podcast_image}}">
                </div>
                <div class="col-md-9">
                    <div class="list_b_con">
                        <span>Podcast</span>
                        <h2>{{podcastDetailRes?.podcast_name}}</h2>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row episodes-list">
    <div class="col-md-8">
        <h4>All Episodes</h4>
        <div class="list_de_sub" *ngFor="let episode of podcastDetailRes?.episodes;let i=index;" routerLink="/podcasts-web/episode/{{episode?.alias}}">
            <div class="row">
                <div class="img-box"><img alt="{{episode?.title}}" src="{{episode?.thumbnail}}"></div>
                <div class="el-content">
                    <h5>{{episode?.title}}</h5>
                    <p>{{episode?.description}}</p>
                    <div class="el-footer">
                        <div class="play_link"><a (click)="playAudio(episode);$event.stopPropagation();"><i class="fa fa-play-circle"
                                    aria-hidden="true"></i></a>
                            <div class="time">{{secondsToDhms(episode?.audio_length_sec)}}</div>
                        </div>
                 
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="podcastDetailRes?.episodes && podcastDetailRes?.episodes?.length == 0">
            <p class="cover-space">No Episodes Available!</p>
        </ng-container>
        <ng-container *ngIf="podcastDetailRes?.episodes && podcastDetailRes?.episodes?.length > 0">
  
            <div class="admin-pagination-div">
                <ul *ngIf="pager.pages && pager.pages.length" class="pagination pagination-control">
                    <ng-container *ngIf="pager.pages.length > 1">
                    <li class="text-page" (click)="clickPageSearch((pager.currentPage*1) - (1*1), 'prev')"
                        [ngClass]="{hidePrevnext:pager.currentPage == 1}">
                        <a title="Go to previous page" >
                            ‹‹ Prev</a>
                    </li>
                    </ng-container>
                 
                    <ng-container *ngIf="pager.pages.length > 1">
                        <li class="text-page"  (click)="clickPageSearch((pager.currentPage*1) + (1*1), 'next')"
                            [ngClass]="{hidePrevnext:pager.currentPage == pager.totalPages}">
                            <a title="Go to next page"
                                >Next ››</a>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </ng-container>
    </div>
    <div class="col-md-4">
        <div class="list_about_sec">
            <h4>About</h4>
            <div class="la-info">
                <p>{{podcastDetailRes?.podcast_description}}</p>
            </div>

        </div>
    </div>
</div> -->

</ng-container>

<div *ngIf="podcastDetailRes && !podcastDetailRes?.podcast_name" class="cover-space">
</div>